import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ko: {
    translation: {
      // 앱 기본
      appName: '안심IN서울',
      slogan: '서울 어디서나, 당신의 곁에',
      importContacts: '주소록에서 불러오기',

      // 내비게이션
      nav: {
        home: '홈',
        location: '위치공유',
        emergency: '긴급신고',
        settings: '설정',
      },

      // 혼잡도
      congestion: {
        title: '혼잡도',
        level1: '여유',
        level2: '보통',
        level3: '약간 붐빔',
        level4: '붐빔',
        level5: '매우 붐빔',
        unknown: '정보 없음',
        populationLabel: '추정 인구',
        population: '{{min}}만 ~ {{max}}만명 추정',
        eventsTitle: '진행 중인 행사',
        updatedAt: '{{time}} 기준',
        forecast: '향후 예보',
        msgLevel1: '사람이 몰려있을 가능성이 적고 이동이 쾌적해요.',
        msgLevel2: '사람들이 다소 있지만 이동에 큰 불편함은 없어요.',
        msgLevel3: '사람들이 몰려있을 가능성이 크고 붐빈다고 느낄 수 있어요. 일부 구간에서는 도보 이동 시 부딪힘이 발생할 수 있어요.',
        msgLevel4: '인파가 붐비고 이동이 불편할 수 있어요. 보행 시 주의가 필요해요.',
        msgLevel5: '인파가 매우 밀집해 있어 혼잡합니다. 안전사고에 각별히 유의하세요.',
      },

      // 지도 & 홈
      map: {
        myLocation: '내 위치',
        zoomIn: '확대',
        zoomOut: '축소',
        filter: '필터',
        allCategory: '전체',
        loading: '데이터 불러오는 중...',
        loadError: '데이터 로딩 실패',
        retry: '다시 시도',
      },

      home: {
        addNewGroup: '+ 새 그룹 추가',
        viewMember: '👁️ 멤버',
        hideMember: '👁️ 해제',
        groupModalTitle: '실시간 그룹 참여 / 생성',
        groupModalDesc: '그룹에서 사용할 본인의 이름을 먼저 입력하세요.',
        namePlaceholder: '본인 이름 (1~10자)',
        joinDivider: '초대 코드로 참여하기',
        codePlaceholder: '초대 코드 6자리',
        joinBtn: '참여',
        createDivider: '또는 새 그룹 만들기',
        groupNamePlaceholder: '새 그룹명 (1~10자)',
        createBtn: '생성',
        groupDetailTitle: '[{{name}}] 상세 정보',
        code: '코드:',
        remainingTime: '⏳ 남은 시간 {{time}}',
        hostBadge: '👑 방장',
        shareInvite: '공유/초대',
        noticePlaceholder: '공지사항 입력...',
        saveBtn: '저장',
        editBtn: '수정',
        deleteBtn: '삭제',
        leaveBtn: '나가기',
        closeGroupBtn: '방 폭파',
        confirmNoticeDelete: '공지사항을 삭제하시겠습니까?',
        noticeUpdateFail: '공지 업데이트에 실패했습니다.',
        noticeDeleteFail: '공지 삭제 실패',
        invalidNameLength: '본인 이름을 2~5글자로 입력해주세요.',
        invalidGroupNameLength: '그룹명을 2~5글자로 입력해주세요.',
        invalidCode: '6자리 코드를 입력해주세요.',
        alreadyJoined: '이미 참여 중인 그룹입니다.',
        maxGroups: '최대 3개의 그룹까지만 참여 가능합니다.',
        createError: '그룹 생성 중 오류가 발생했습니다.',
        shareTitle: '그룹 위치 공유 참여',
        shareText: '{{name}} 그룹에 참여하세요!\n참여 코드: {{code}}\n\n안심 IN 서울 앱에서 코드를 입력하면 실시간으로 서로의 위치를 확인할 수 있습니다.',
        shareSuccess: '공유 메시지가 복사되었습니다.',
        needMyLocation: '내 위치를 먼저 확인해 주세요.',
        routeNotFound: '경로를 찾을 수 없습니다.',
        routeError: '경로 조회 중 오류가 발생했습니다.',
        manualLocationTitle: '내 위치 수동 설정',
        manualLocationDesc: '위치 접근이 제한되어 있습니다. 그룹 참여를 위해 장소명(예: 강남역)이나 주소를 검색해 주세요.',
        manualLocationPlaceholder: '장소명 또는 주소 검색',
        searchBtn: '검색',
        searchFail: '검색 결과를 찾을 수 없습니다.',
        groupClosedAlert: '방장이 [{{name}}] 그룹 공유를 종료했습니다.',
        groupExpiredAlert: '24시간이 경과하여 [{{name}}] 방이 자동 해제되었습니다.',
        distanceM: '{{n}}m',
        distanceKm: '{{n}}km',
        timeMin: '{{n}}분',
        timeHourMin: '{{h}}시간 {{m}}분',
        me: '나',
        permissionDenied: '위치 권한이 거부되었습니다. 주소창의 자물쇠 아이콘을 클릭하여 설정을 확인해 주세요.',
        noticeNotification: '[{{name}}] 공지',
        locationSuccess: '내 위치 파악 성공:',
        hotspotWarningTitle: '🚨 인파 밀집 주의 지역',
        hotspotWarningDesc: '현재 명동, 홍대, 이태원 일대에 많은 인파가 몰려 있습니다. 이동 시 안전에 유의하세요.',
      },

      // 카테고리
      category: {
        all: '전체',
        station: '지하철역',
        commerce: '상업지구',
        entertainment: '문화·오락',
        food: '음식·식당',
        tourism: '관광명소',
        market: '시장',
        landmark: '랜드마크',
        park: '공원',
        education: '대학교',
      },

      // 위치 공유 (1:1 포함)
      sharing: {
        title: '위치 공유',
        start: '공유 시작',
        stop: '공유 중지',
        request: '위치 요청',
        pending: '승인 대기 중',
        approved: '공유 중',
        rejected: '거절됨',
        noGroup: '공유 그룹이 없습니다',
        createGroup: '그룹 만들기',
        joinGroup: '그룹 참여',
        myLocation: '내 위치',
        lastSeen: '{{time}} 전',
      },

      privateSharing: {
        title: '1:1 위치 공유 (유료)',
        desc: '지정한 보호자 또는 지인과 1:1로 위치를 공유합니다.',
        paidInfo: '💡 1:1 공유는 인원당 결제가 필요한 프리미엄 서비스입니다. \n 한 번 삭제하면 재등록 시 다시 결제가 필요하니 주의하세요.',
        myMembers: '나의 공유 멤버 ({{count}})',
        demoBtn: '🚀 데모생성',
        addBtn: '추가',
        emptyTitle: '등록된 멤버가 없습니다',
        emptyDesc: '연락처에서 위치를 공유할 소중한 사람을 추가해 보세요.',
        addMemberBtn: '멤버 추가하기',
        unnamed: '이름 미설정',
        active: '공유 중',
        inactive: '비활성',
        requestLocation: '위치 요청',
        start: '시작',
        stop: '중단',
        delete: '삭제',
        addModalTitle: '연락처에서 추가',
        payAddBtn: '결제/추가',
        editModalTitle: '이름 수정',
        editModalDesc: '멤버의 별칭을 입력하세요 ({{phone}})',
        editModalPlaceholder: '예: 우리 엄마, 홍길동',
        save: '저장',
        cancel: '취소',
        confirmDelete: '정말 삭제하시겠습니까? 삭제 후 다시 등록하려면 재결제가 필요합니다.',
        demoCreated: '데모 멤버가 추가되었습니다.',
        confirmRequest: '{{name}}님에게 위치 공유 요청을 보낼까요? (인원당 1,100원 결제 필요)',
        requestSuccess: '결제가 완료되고 요청을 보냈습니다.',
        requestFail: '요청 실패: {{msg}}',
        updateFail: '이름 수정 실패: {{msg}}',
        requestSent: '{{name}}님에게 위치 공유 요청을 보냈습니다. 상대방이 수락하면 지도에 표시됩니다.'
      },

      // Dead Man Switch
      deadman: {
        title: '안전 스위치',
        description: '일정 시간 움직임이 없으면 지인에게 자동 알림을 전송합니다.',
        activate: '활성화',
        deactivate: '비활성화',
        active: '활성화됨',
        threshold: '알림 임계 시간',
        minutes: '{{n}}분',
        contacts: '알림 수신자',
        addContact: '수신자 추가',
        triggered: '안전 스위치가 작동되었습니다!',
      },

      // 긴급신고
      emergency: {
        title: '긴급신고',
        police: '경찰 112',
        fire: '소방·구급 119',
        myAddress: '현재 위치',
        copyAddress: '주소 복사',
        copied: '복사됨',
        call112: '112 신고',
        call119: '119 신고',
        description: '긴급상황 시 원터치 신고',
        addressLoading: '주소 불러오는 중...',
        findingLocation: '위치 확인 중...',
        addressNotFound: '주소를 찾을 수 없습니다',
        needPermission: '위치 권한이 필요합니다',
        policeLabel: '경찰청',
        fireLabel: '소방청·구급',
        gettingLocation: '위치 불러오는 중...',
        getCurrentLocation: '현재 위치 확인',
        foreignerTip: '💡 외국인이라면 이 주소를 신고 시 읽어주세요',
        foreignerTipEn: 'Share this address when calling emergency services',
        sosTitle: '지정 연락처 (SOS)',
        delete: '삭제',
        edit: '수정',
        cancel: '취소',
        save: '저장하기',
        sendSms: '문자 메시지로 전송하기',
        nameRelation: '이름 / 관계',
        phone: '전화번호',
        presetMessage: '미리 설정할 메시지',
        namePlaceholder: '예: 어머니, 홍길동',
        phonePlaceholder: '숫자만 입력 (예: 01012345678)',
        defaultContact: '지정 연락처',
        plusCurrentAddress: '+ 현재 내 위치 주소',
        guideTitle: '긴급상황 대처법',
        guidePolice: '범죄·사고·위험 신고 (Police)',
        guideFire: '화재·응급환자·구조 요청 (Fire & EMS)',
        guideCivil: '서울시 민원·생활불편 신고',
        guideTourist: '외국인 관광불편 24시간 신고',
        confirmDelete: '지정된 연락처를 삭제하시겠습니까?',
        flashcardTitle: '도움 요청 카드',
        flashcardMessage: '저는 외국인입니다. 도움이 필요합니다. 경찰(112)이나 소방서(119)에 연락해 주세요.',
        flashcardSpeak: '음성으로 듣기',
        guideTourist1330: '관광통역안내 1330'
      },

      // 날씨
      weather: {
        temp: '기온',
        humidity: '습도',
        pm10: '미세먼지',
        airQuality: '공기질',
        uv: '자외선',
      },

      // 교통
      traffic: {
        title: '교통상황',
        smooth: '원활',
        slow: '서행',
        congested: '정체',
      },

      // 설정
      settings: {
        title: '설정',
        language: '언어',
        notification: '알림',
        congestionAlert: '혼잡도 알림',
        radius: '알림 반경',
        theme: '테마',
        about: '앱 정보',
        version: '버전',
        privacy: '개인정보처리방침',
        terms: '이용약관',
        on: '켜짐',
        off: '꺼짐',
        persons: '{{n}}명',
        appTitle: '안심 IN 서울',
        valueBeta: '0.1.0 Beta',
        valueDistance: '500m',
        valueTime: '60분',
        valuePersons: '0명',
        inviteTitle: '친구 초대',
        inviteMenu: '지인에게 앱 추천하기',
        inviteMessage: '안심IN서울 앱을 설치하고 안전하게 위치를 공유해보세요!\n앱 다운로드: https://ansim-in-seoul.vercel.app',
        inviteModalTitle: '초대장 보내기',
        inviteSendBtn: '초대 문자 전송',
        importContacts: '주소록에서 불러오기'
      },

      // 안전/편의시설
      safety: {
        policeTitle: '경찰 관서',
        hospitalTitle: '의료 기관',
        embassyTitle: '외교 공관',
        defaultPhonePolice: '112 (긴급)',
        defaultPhoneHospital: '119 (응급) / 1339',
        defaultPhoneEmbassy: '1345 (외국인종합안내)',
        visitWebsite: '공식 홈페이지 방문',
        addressPlaceholder: '해당 기관에 방문하여 상세한 안내를 받으세요.',
        noticeTitle: '긴급 안내:',
        noticeDesc: '외국인 체류 및 여행 중 위급 상황 발생 시 24시간 도움을 받을 수 있습니다. 앱 하단의 \'긴급신고\' 메뉴를 이용하면 더 빠른 대처가 가능합니다.',
      },

      // 오류
      error: {
        network: '네트워크 오류가 발생했습니다.',
        permission: '위치 권한이 필요합니다.',
        unknown: '알 수 없는 오류가 발생했습니다.',
      },
    },
  },

  en: {
    translation: {
      appName: 'Ansim IN Seoul',
      slogan: 'Everywhere in Seoul, by your side',
      importContacts: 'Load from Contacts',

      nav: {
        home: 'Home',
        location: 'Location',
        emergency: 'Emergency',
        settings: 'Settings',
      },

      congestion: {
        title: 'Crowd Level',
        level1: 'Uncrowded',
        level2: 'Normal',
        level3: 'Slightly Crowded',
        level4: 'Crowded',
        level5: 'Very Crowded',
        unknown: 'No Data',
        populationLabel: 'Est. Population',
        population: '~{{min}}k - {{max}}k people',
        eventsTitle: 'Ongoing Events',
        updatedAt: 'As of {{time}}',
        forecast: 'Forecast',
        msgLevel1: 'The area is uncrowded. You can walk around comfortably.',
        msgLevel2: 'The area is normal. You may see people, but walking is smooth.',
        msgLevel3: 'The area is slightly crowded. You might feel it\'s busy, and minor bumping can occur in dense spots.',
        msgLevel4: 'The area is crowded. Movement can be uncomfortable, please walk with caution.',
        msgLevel5: 'The area is very crowded. Please move carefully to avoid accidents.',
      },

      map: {
        myLocation: 'My Location',
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
        filter: 'Filter',
        allCategory: 'All',
        loading: 'Loading data...',
        loadError: 'Failed to load data',
        retry: 'Retry',
      },

      home: {
        addNewGroup: '+ Add New Group',
        viewMember: '👁️ Members',
        hideMember: '👁️ Hide',
        groupModalTitle: 'Join / Create Group',
        groupModalDesc: 'Enter your name to use in the group first.',
        namePlaceholder: 'Your name (2~5 chars)',
        joinDivider: 'Join with Code',
        codePlaceholder: '6-digit Code',
        joinBtn: 'Join',
        createDivider: 'Or Create a New Group',
        groupNamePlaceholder: 'New Group Name (2~5 chars)',
        createBtn: 'Create',
        groupDetailTitle: '[{{name}}] Details',
        code: 'Code:',
        remainingTime: '⏳ Time left {{time}}',
        hostBadge: '👑 Host',
        shareInvite: 'Share/Invite',
        noticePlaceholder: 'Enter notice...',
        saveBtn: 'Save',
        editBtn: 'Edit',
        deleteBtn: 'Delete',
        leaveBtn: 'Leave',
        closeGroupBtn: 'Close Group',
        confirmNoticeDelete: 'Are you sure you want to delete the notice?',
        noticeUpdateFail: 'Failed to update notice.',
        noticeDeleteFail: 'Failed to delete notice.',
        invalidNameLength: 'Please enter your name in 2-5 characters.',
        invalidGroupNameLength: 'Please enter a group name in 2-5 characters.',
        invalidCode: 'Please enter a 6-digit code.',
        alreadyJoined: 'You have already joined this group.',
        maxGroups: 'You can join up to 3 groups.',
        createError: 'Error occurred while creating the group.',
        shareTitle: 'Join Location Sharing',
        shareText: 'Join the {{name}} group!\nCode: {{code}}\n\nEnter this code in the Ansim IN Seoul app to share your real-time locations.',
        shareSuccess: 'Share message copied to clipboard.',
        needMyLocation: 'Please confirm your location first.',
        routeNotFound: 'Route not found.',
        routeError: 'Error occurred while fetching route.',
        manualLocationTitle: 'Set Location Manually',
        manualLocationDesc: 'Location access is denied. Please search for a place (e.g., Gangnam Station) or address to join the group.',
        manualLocationPlaceholder: 'Search for a place or address',
        searchBtn: 'Search',
        searchFail: 'No search results found.',
        groupClosedAlert: 'Host has closed the [{{name}}] group.',
        groupExpiredAlert: '24 hours have passed, [{{name}}] group has been automatically closed.',
        distanceM: '{{n}}m',
        distanceKm: '{{n}}km',
        timeMin: '{{n}} min',
        timeHourMin: '{{h}} hr {{m}} min',
        me: 'Me',
        permissionDenied: 'Location permission denied. Check settings.',
        noticeNotification: '[{{name}}] Notice',
        locationSuccess: 'Location identified successfully:',
        hotspotWarningTitle: '🚨 High Crowd Density Warning',
        hotspotWarningDesc: 'High crowds are currently reported in Myeongdong, Hongdae, and Itaewon. Please stay safe.',
      },

      category: {
        all: 'All',
        station: 'Subway',
        commerce: 'Commercial',
        entertainment: 'Entertainment',
        food: 'Food & Dining',
        tourism: 'Tourist Spot',
        market: 'Market',
        landmark: 'Landmark',
        park: 'Park',
        education: 'University',
      },

      sharing: {
        title: 'Location Sharing',
        start: 'Start Sharing',
        stop: 'Stop Sharing',
        request: 'Request Location',
        pending: 'Pending Approval',
        approved: 'Sharing',
        rejected: 'Rejected',
        noGroup: 'No sharing group',
        createGroup: 'Create Group',
        joinGroup: 'Join Group',
        myLocation: 'My Location',
        lastSeen: '{{time}} ago',
      },

      privateSharing: {
        title: '1:1 Location Sharing (Paid)',
        desc: 'Share your location 1:1 with a guardian or friend.',
        paidInfo: '💡 1:1 sharing is a premium service requiring payment per person. \n If deleted, repayment is needed to re-register.',
        myMembers: 'My Sharing Members ({{count}})',
        demoBtn: '🚀 Demo',
        addBtn: 'Add',
        emptyTitle: 'No registered members',
        emptyDesc: 'Add a loved one from your contacts to share your location.',
        addMemberBtn: 'Add Member',
        unnamed: 'No Name',
        active: 'Sharing',
        inactive: 'Inactive',
        requestLocation: 'Request Location',
        start: 'Start',
        stop: 'Stop',
        delete: 'Delete',
        addModalTitle: 'Add from Contacts',
        payAddBtn: 'Pay/Add',
        editModalTitle: 'Edit Name',
        editModalDesc: 'Enter member\'s nickname ({{phone}})',
        editModalPlaceholder: 'e.g. My Mom, John Doe',
        save: 'Save',
        cancel: 'Cancel',
        confirmDelete: 'Are you sure you want to delete? Re-registering will require payment.',
        demoCreated: 'Demo member added.',
        confirmRequest: 'Send location sharing request to {{name}}? (Requires 1,100 KRW payment per person)',
        requestSuccess: 'Payment completed and request sent.',
        requestFail: 'Request failed: {{msg}}',
        updateFail: 'Failed to update name: {{msg}}',
        requestSent: 'Location request sent to {{name}}. They will appear on the map when accepted.'
      },

      deadman: {
        title: 'Safety Switch',
        description: 'Automatically alerts your contacts if no movement is detected.',
        activate: 'Activate',
        deactivate: 'Deactivate',
        active: 'Active',
        threshold: 'Alert Threshold',
        minutes: '{{n}} min',
        contacts: 'Alert Contacts',
        addContact: 'Add Contact',
        triggered: 'Safety Switch has been triggered!',
      },

      emergency: {
        title: 'Emergency',
        police: 'Police 112',
        fire: 'Fire & EMS 119',
        myAddress: 'Current Location',
        copyAddress: 'Copy Address',
        copied: 'Copied',
        call112: 'Call 112',
        call119: 'Call 119',
        description: 'One-tap emergency call',
        addressLoading: 'Loading address...',
        findingLocation: 'Finding location...',
        addressNotFound: 'Address not found',
        needPermission: 'Location permission needed',
        policeLabel: 'Police',
        fireLabel: 'Fire·Ambulance',
        gettingLocation: 'Getting location...',
        getCurrentLocation: 'Get Current Location',
        foreignerTip: '💡 If you are a foreigner, please read this address when reporting',
        foreignerTipEn: 'Share this address when calling emergency services',
        sosTitle: 'SOS to Contact',
        delete: 'Delete',
        edit: 'Edit',
        cancel: 'Cancel',
        save: 'Save',
        sendSms: 'Send via SMS',
        nameRelation: 'Name / Relation',
        phone: 'Phone Number',
        presetMessage: 'Preset Message',
        namePlaceholder: 'e.g. Mother, John Doe',
        phonePlaceholder: 'Numbers only (e.g. 01012345678)',
        defaultContact: 'Designated Contact',
        plusCurrentAddress: '+ Current location address',
        guideTitle: 'Emergency Guide',
        guidePolice: 'Report Crime, Accident, Danger (Police)',
        guideFire: 'Report Fire, Medical Emergency, Rescue (Fire & EMS)',
        guideCivil: 'Seoul Civil Complaints',
        guideTourist: 'Foreign Tourist Complaints (24/7)',
        confirmDelete: 'Are you sure you want to delete this contact?',
        flashcardTitle: 'Help Request Card (Show to Korean)',
        flashcardMessage: 'I am a foreigner and need help. Please call 112 or 119.',
        flashcardSpeak: 'Play Audio',
        guideTourist1330: 'Tourist Police 1330'
      },

      weather: {
        temp: 'Temperature',
        humidity: 'Humidity',
        pm10: 'Fine Dust',
        airQuality: 'Air Quality',
        uv: 'UV Index',
      },

      traffic: {
        title: 'Traffic',
        smooth: 'Smooth',
        slow: 'Slow',
        congested: 'Congested',
      },

      settings: {
        title: 'Settings',
        language: 'Language',
        notification: 'Notifications',
        congestionAlert: 'Crowd Alert',
        radius: 'Alert Radius',
        theme: 'Theme',
        about: 'About',
        version: 'Version',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        on: 'On',
        off: 'Off',
        persons: '{{n}} person(s)',
        appTitle: 'Ansim IN Seoul',
        valueBeta: '0.1.0 Beta',
        valueDistance: '500m',
        valueTime: '60 min',
        valuePersons: '0 person(s)',
        inviteTitle: 'Invite Friends',
        inviteMenu: 'Recommend App to Friends',
        inviteMessage: 'Install Ansim IN Seoul and share your location safely!\nDownload: https://ansim-in-seoul.vercel.app',
        inviteModalTitle: 'Send Invitation',
        inviteSendBtn: 'Send SMS',
        importContacts: 'Load from Contacts',
      },

      safety: {
        policeTitle: 'Police Station',
        hospitalTitle: 'Hospital / Medical Center',
        embassyTitle: 'Embassy',
        defaultPhonePolice: '112 (Emergency)',
        defaultPhoneHospital: '119 (Emergency) / 1339',
        defaultPhoneEmbassy: '1345 (Immigration Contact)',
        visitWebsite: 'Visit Official Website',
        addressPlaceholder: 'Please visit the facility for detailed assistance.',
        noticeTitle: 'Emergency Notice:',
        noticeDesc: '24/7 assistance is available for foreigners during emergencies. Use the Emergency menu at the bottom for immediate response.',
      },

      error: {
        network: 'Network error occurred.',
        permission: 'Location permission is required.',
        unknown: 'An unknown error occurred.',
      },
    }
  },

  ja: {
  "translation": {
    "appName": "安心 IN ソウル",
    "slogan": "ソウルのどこでも、あなたのそばに",
    "importContacts": "連絡先からインポート",
    "nav": {
      "home": "ホーム",
      "location": "位置共有",
      "emergency": "緊急通報",
      "settings": "設定"
    },
    "congestion": {
      "title": "混雑度",
      "level1": "空いている",
      "level2": "普通",
      "level3": "やや混雑",
      "level4": "混雑",
      "level5": "非常に混雑",
      "unknown": "情報なし",
      "populationLabel": "推定人口",
      "population": "約{{min}}万〜{{max}}万人",
      "eventsTitle": "開催中のイベント",
      "updatedAt": "{{time}} 現在",
      "forecast": "予測",
      "msgLevel1": "空いています。快適に歩けます。",
      "msgLevel2": "普通です。人はいますが、スムーズに歩けます。",
      "msgLevel3": "やや混雑しています。少し人が多く、ぶつかる可能性があります。",
      "msgLevel4": "混雑しています。移動が不便かもしれません。ご注意ください。",
      "msgLevel5": "非常に混雑しています。事故に注意して慎重に移動してください。"
    },
    "map": {
      "myLocation": "現在地",
      "zoomIn": "拡大",
      "zoomOut": "縮小",
      "filter": "フィルター",
      "allCategory": "すべて",
      "loading": "データを読み込み中...",
      "loadError": "データの読み込みに失敗しました",
      "retry": "再試行"
    },
    "home": {
      "addNewGroup": "+ 新しいグループを追加",
      "viewMember": "👁️ メンバー",
      "hideMember": "👁️ 隠す",
      "groupModalTitle": "グループに参加 / 作成",
      "groupModalDesc": "グループで使用する名前を先に入力してください。",
      "namePlaceholder": "あなたの名前 (2〜5文字)",
      "joinDivider": "コードで参加",
      "codePlaceholder": "6桁のコード",
      "joinBtn": "参加",
      "createDivider": "または新しく作成",
      "groupNamePlaceholder": "新しいグループ名 (2〜5文字)",
      "createBtn": "作成",
      "groupDetailTitle": "[{{name}}] の詳細",
      "code": "コード:",
      "remainingTime": "⏳ 残り時間 {{time}}",
      "hostBadge": "👑 ホスト",
      "shareInvite": "共有/招待",
      "noticePlaceholder": "お知らせを入力...",
      "saveBtn": "保存",
      "editBtn": "編集",
      "deleteBtn": "削除",
      "leaveBtn": "退出",
      "closeGroupBtn": "グループを終了",
      "confirmNoticeDelete": "お知らせを削除してもよろしいですか？",
      "noticeUpdateFail": "お知らせの更新に失敗しました。",
      "noticeDeleteFail": "お知らせの削除に失敗しました。",
      "invalidNameLength": "名前は2〜5文字で入力してください。",
      "invalidGroupNameLength": "グループ名は2〜5文字で入力してください。",
      "invalidCode": "6桁のコードを入力してください。",
      "alreadyJoined": "すでにこのグループに参加しています。",
      "maxGroups": "最大3つのグループに参加できます。",
      "createError": "グループの作成中にエラーが発生しました。",
      "shareTitle": "位置共有に参加",
      "shareText": "{{name}}グループに参加しましょう！\nコード: {{code}}\n\n安心 IN ソウルアプリでこのコードを入力してリアルタイムの位置情報を共有しましょう。",
      "shareSuccess": "招待メッセージをコピーしました。",
      "needMyLocation": "先に現在地を確認してください。",
      "routeNotFound": "経路が見つかりません。",
      "routeError": "経路の取得中にエラーが発生しました。",
      "manualLocationTitle": "手動で位置を設定",
      "manualLocationDesc": "位置情報の権限が拒否されました。場所（例：江南駅）や住所を検索してグループに参加してください。",
      "manualLocationPlaceholder": "場所や住所を検索",
      "searchBtn": "検索",
      "searchFail": "検索結果がありません。",
      "groupClosedAlert": "ホストが[{{name}}]グループを終了しました。",
      "groupExpiredAlert": "24時間が経過し、[{{name}}]グループは自動的に終了しました。",
      "distanceM": "{{n}}m",
      "distanceKm": "{{n}}km",
      "timeMin": "{{n}}分",
      "timeHourMin": "{{h}}時間 {{m}}分",
      "me": "私",
      "permissionDenied": "位置情報の権限が拒否されました。設定を確認してください。",
      "noticeNotification": "[{{name}}] お知らせ",
      "locationSuccess": "位置情報を特定しました:",
      "hotspotWarningTitle": "🚨 混雑警告",
      "hotspotWarningDesc": "現在、明洞・弘大・梨泰院エリアが大変混雑しています。安全にご注意ください。"
    },
    "category": {
      "all": "すべて",
      "station": "地下鉄",
      "commerce": "商業",
      "entertainment": "エンターテイメント",
      "food": "飲食",
      "tourism": "観光地",
      "market": "市場",
      "landmark": "ランドマーク",
      "park": "公園",
      "education": "大学"
    },
    "sharing": {
      "title": "位置共有",
      "start": "共有開始",
      "stop": "共有停止",
      "request": "位置をリクエスト",
      "pending": "承認待ち",
      "approved": "共有中",
      "rejected": "拒否されました",
      "noGroup": "共有グループなし",
      "createGroup": "グループ作成",
      "joinGroup": "グループ参加",
      "myLocation": "現在地",
      "lastSeen": "{{time}}前"
    },
    "privateSharing": {
      "title": "1:1 位置共有 (有料)",
      "desc": "家族や友人と1:1で位置を共有します。",
      "paidInfo": "💡 1:1共有は1人あたり有料のプレミアムサービスです。\n削除した場合、再登録には再度決済が必要です。",
      "myMembers": "私の共有メンバー ({{count}})",
      "demoBtn": "🚀 デモ",
      "addBtn": "追加",
      "emptyTitle": "登録されたメンバーがいません",
      "emptyDesc": "連絡先から大切な人を追加して位置を共有しましょう。",
      "addMemberBtn": "メンバー追加",
      "unnamed": "名前なし",
      "active": "共有中",
      "inactive": "非アクティブ",
      "requestLocation": "位置をリクエスト",
      "start": "開始",
      "stop": "停止",
      "delete": "削除",
      "addModalTitle": "連絡先から追加",
      "payAddBtn": "決済/追加",
      "editModalTitle": "名前を編集",
      "editModalDesc": "メンバーのニックネームを入力 ({{phone}})",
      "editModalPlaceholder": "例: お母さん、山田太郎",
      "save": "保存",
      "cancel": "キャンセル",
      "confirmDelete": "本当に削除しますか？再登録には決済が必要です。",
      "demoCreated": "デモメンバーが追加されました。",
      "confirmRequest": "{{name}}に位置共有リクエストを送信しますか？ (1人あたり1,100ウォンの決済が必要)",
      "requestSuccess": "決済が完了し、リクエストを送信しました。",
      "requestFail": "リクエスト失敗: {{msg}}",
      "updateFail": "名前の更新に失敗しました: {{msg}}",
      "requestSent": "{{name}}に位置リクエストを送信しました。承認されるとマップに表示されます。"
    },
    "deadman": {
      "title": "セーフティスイッチ",
      "description": "動きが検出されない場合、連絡先に自動で通知します。",
      "activate": "有効にする",
      "deactivate": "無効にする",
      "active": "アクティブ",
      "threshold": "通知のしきい値",
      "minutes": "{{n}}分",
      "contacts": "緊急連絡先",
      "addContact": "連絡先を追加",
      "triggered": "セーフティスイッチが作動しました！"
    },
    "emergency": {
      "title": "緊急通報",
      "police": "警察 112",
      "fire": "消防・救急 119",
      "myAddress": "現在地",
      "copyAddress": "住所をコピー",
      "copied": "コピー完了",
      "call112": "112に電話",
      "call119": "119に電話",
      "description": "ワンタップ緊急通報",
      "addressLoading": "住所を読み込み中...",
      "findingLocation": "位置を検索中...",
      "addressNotFound": "住所が見つかりません",
      "needPermission": "位置情報の権限が必要です",
      "policeLabel": "警察",
      "fireLabel": "消防・救急",
      "gettingLocation": "位置を取得中...",
      "getCurrentLocation": "現在地を取得",
      "foreignerTip": "💡 外国人の方は通報時にこの住所を読み上げてください",
      "foreignerTipEn": "Share this address when calling emergency services",
      "sosTitle": "連絡先にSOS",
      "delete": "削除",
      "edit": "編集",
      "cancel": "キャンセル",
      "save": "保存",
      "sendSms": "SMSで送信",
      "nameRelation": "名前 / 関係",
      "phone": "電話番号",
      "presetMessage": "定型メッセージ",
      "namePlaceholder": "例: 母、山田太郎",
      "phonePlaceholder": "数字のみ (例: 01012345678)",
      "defaultContact": "指定連絡先",
      "plusCurrentAddress": "+ 現在地の住所",
      "guideTitle": "緊急時ガイド",
      "guidePolice": "犯罪・事故・危険の通報 (警察)",
      "guideFire": "火災・救急・救助の通報 (消防)",
      "guideCivil": "ソウル市に関する苦情・相談",
      "guideTourist": "外国人観光客の苦情 (24時間)",
      "confirmDelete": "この連絡先を削除してもよろしいですか？",
      "flashcardTitle": "ヘルプカード (韓国人に見せてください)",
      "flashcardMessage": "私は外国人です。助けが必要です。警察(112)や消防署(119)に連絡してください。",
      "flashcardSpeak": "音声を再生",
      "guideTourist1330": "観光警察 1330"
    },
    "weather": {
      "temp": "気温",
      "humidity": "湿度",
      "pm10": "微小粒子状物質",
      "airQuality": "空気質",
      "uv": "紫外線指数"
    },
    "traffic": {
      "title": "交通情報",
      "smooth": "スムーズ",
      "slow": "やや渋滞",
      "congested": "渋滞"
    },
    "settings": {
      "title": "設定",
      "language": "言語",
      "notification": "通知",
      "congestionAlert": "混雑アラート",
      "radius": "アラート半径",
      "theme": "テーマ",
      "about": "アプリについて",
      "version": "バージョン",
      "privacy": "プライバシーポリシー",
      "terms": "利用規約",
      "on": "オン",
      "off": "オフ",
      "persons": "{{n}} 人",
      "appTitle": "安心 IN ソウル",
      "valueBeta": "0.1.0 Beta",
      "valueDistance": "500m",
      "valueTime": "60分",
      "valuePersons": "0 人",
      "inviteTitle": "友達を招待",
      "inviteMenu": "アプリを友達にすすめる",
      "inviteMessage": "安心 IN ソウルをインストールして安全に位置を共有しましょう！\nダウンロード: https://ansim-in-seoul.vercel.app",
      "inviteModalTitle": "招待状を送信",
      "inviteSendBtn": "SMSで送信",
      "importContacts": "連絡先からインポート"
    },
    "safety": {
      "policeTitle": "警察署",
      "hospitalTitle": "病院・医療機関",
      "embassyTitle": "大使館",
      "defaultPhonePolice": "112 (緊急)",
      "defaultPhoneHospital": "119 (緊急) / 1339",
      "defaultPhoneEmbassy": "1345 (出入国管理)",
      "visitWebsite": "公式サイトへ",
      "addressPlaceholder": "詳細なサポートは直接施設を訪問してください。",
      "noticeTitle": "緊急時のお知らせ:",
      "noticeDesc": "外国人の方は緊急時に24時間サポートを受けられます。下部の「緊急通報」メニューをご利用ください。"
    },
    "error": {
      "network": "ネットワークエラーが発生しました。",
      "permission": "位置情報の権限が必要です。",
      "unknown": "不明なエラーが発生しました。"
    }
  }
},
  zh: {
  "translation": {
    "appName": "安心 IN 首尔",
    "slogan": "首尔的每个角落，都有我们陪伴",
    "importContacts": "从通讯录导入",
    "nav": {
      "home": "首页",
      "location": "位置共享",
      "emergency": "紧急报警",
      "settings": "设置"
    },
    "congestion": {
      "title": "拥挤度",
      "level1": "空闲",
      "level2": "正常",
      "level3": "微拥挤",
      "level4": "拥挤",
      "level5": "非常拥挤",
      "unknown": "暂无数据",
      "populationLabel": "预估人数",
      "population": "约 {{min}}万 ~ {{max}}万人",
      "eventsTitle": "正在举行的活动",
      "updatedAt": "截至 {{time}}",
      "forecast": "预测",
      "msgLevel1": "当前区域比较空闲，可以舒适地漫步。",
      "msgLevel2": "当前区域人流量正常，行走顺畅。",
      "msgLevel3": "当前区域有些拥挤，可能会发生轻微的碰撞。",
      "msgLevel4": "当前区域拥挤，移动可能会有些不便，请注意安全。",
      "msgLevel5": "当前区域非常拥挤，请务必小心移动以防发生事故。"
    },
    "map": {
      "myLocation": "我的位置",
      "zoomIn": "放大",
      "zoomOut": "缩小",
      "filter": "筛选",
      "allCategory": "全部",
      "loading": "正在加载数据...",
      "loadError": "数据加载失败",
      "retry": "重试"
    },
    "home": {
      "addNewGroup": "+ 添加新群组",
      "viewMember": "👁️ 成员",
      "hideMember": "👁️ 隐藏",
      "groupModalTitle": "加入 / 创建群组",
      "groupModalDesc": "请先输入您在群组中使用的昵称。",
      "namePlaceholder": "您的昵称 (2~5个字符)",
      "joinDivider": "通过邀请码加入",
      "codePlaceholder": "6位邀请码",
      "joinBtn": "加入",
      "createDivider": "或创建一个新群组",
      "groupNamePlaceholder": "新群组名称 (2~5个字符)",
      "createBtn": "创建",
      "groupDetailTitle": "[{{name}}] 详情",
      "code": "邀请码:",
      "remainingTime": "⏳ 剩余时间 {{time}}",
      "hostBadge": "👑 群主",
      "shareInvite": "分享/邀请",
      "noticePlaceholder": "请输入公告...",
      "saveBtn": "保存",
      "editBtn": "编辑",
      "deleteBtn": "删除",
      "leaveBtn": "退出",
      "closeGroupBtn": "解散群组",
      "confirmNoticeDelete": "您确定要删除该公告吗？",
      "noticeUpdateFail": "公告更新失败。",
      "noticeDeleteFail": "公告删除失败。",
      "invalidNameLength": "请输入2~5个字符的昵称。",
      "invalidGroupNameLength": "请输入2~5个字符的群组名称。",
      "invalidCode": "请输入6位邀请码。",
      "alreadyJoined": "您已经加入了该群组。",
      "maxGroups": "最多只能加入3个群组。",
      "createError": "创建群组时发生错误。",
      "shareTitle": "加入位置共享",
      "shareText": "快来加入 {{name}} 群组吧！\n邀请码: {{code}}\n\n在“安心 IN 首尔”应用中输入此邀请码，即可共享实时位置。",
      "shareSuccess": "邀请信息已复制到剪贴板。",
      "needMyLocation": "请先确认您的当前位置。",
      "routeNotFound": "未找到路线。",
      "routeError": "获取路线时发生错误。",
      "manualLocationTitle": "手动设置位置",
      "manualLocationDesc": "定位权限被拒绝。请搜索地点（如：江南站）或地址以加入群组。",
      "manualLocationPlaceholder": "搜索地点或地址",
      "searchBtn": "搜索",
      "searchFail": "未找到搜索结果。",
      "groupClosedAlert": "群主已解散 [{{name}}] 群组。",
      "groupExpiredAlert": "24小时已过，[{{name}}] 群组已自动解散。",
      "distanceM": "{{n}}米",
      "distanceKm": "{{n}}公里",
      "timeMin": "{{n}} 分钟",
      "timeHourMin": "{{h}} 小时 {{m}} 分钟",
      "me": "我",
      "permissionDenied": "定位权限被拒绝，请检查系统设置。",
      "noticeNotification": "[{{name}}] 公告",
      "locationSuccess": "已成功获取位置:",
      "hotspotWarningTitle": "🚨 拥挤警告",
      "hotspotWarningDesc": "目前明洞、弘大、梨泰院区域人员密集，请注意安全。"
    },
    "category": {
      "all": "全部",
      "station": "地铁站",
      "commerce": "商业区",
      "entertainment": "娱乐",
      "food": "餐饮",
      "tourism": "旅游景点",
      "market": "传统市场",
      "landmark": "地标",
      "park": "公园",
      "education": "大学"
    },
    "sharing": {
      "title": "位置共享",
      "start": "开始共享",
      "stop": "停止共享",
      "request": "请求位置",
      "pending": "等待批准",
      "approved": "共享中",
      "rejected": "已拒绝",
      "noGroup": "暂无共享群组",
      "createGroup": "创建群组",
      "joinGroup": "加入群组",
      "myLocation": "我的位置",
      "lastSeen": "{{time}}前"
    },
    "privateSharing": {
      "title": "1:1 位置共享 (付费)",
      "desc": "与家人或朋友进行 1:1 位置共享。",
      "paidInfo": "💡 1:1 共享是高级服务，需按人头付费。\n删除后重新添加需要再次付费。",
      "myMembers": "我的共享成员 ({{count}})",
      "demoBtn": "🚀 演示",
      "addBtn": "添加",
      "emptyTitle": "暂无注册成员",
      "emptyDesc": "请从通讯录中添加您关心的人以共享位置。",
      "addMemberBtn": "添加成员",
      "unnamed": "未命名",
      "active": "共享中",
      "inactive": "未激活",
      "requestLocation": "请求位置",
      "start": "开始",
      "stop": "停止",
      "delete": "删除",
      "addModalTitle": "从通讯录添加",
      "payAddBtn": "付款/添加",
      "editModalTitle": "编辑名称",
      "editModalDesc": "请输入成员的昵称 ({{phone}})",
      "editModalPlaceholder": "例如：妈妈、张三",
      "save": "保存",
      "cancel": "取消",
      "confirmDelete": "确定要删除吗？重新注册需要再次付费。",
      "demoCreated": "演示成员已添加。",
      "confirmRequest": "要向 {{name}} 发送位置共享请求吗？ (每人需支付 1,100 韩元)",
      "requestSuccess": "付款完成，请求已发送。",
      "requestFail": "请求失败：{{msg}}",
      "updateFail": "名称更新失败：{{msg}}",
      "requestSent": "已向 {{name}} 发送位置请求。对方同意后将在地图上显示。"
    },
    "deadman": {
      "title": "安全开关",
      "description": "若检测不到您的移动，将自动通知紧急联系人。",
      "activate": "激活",
      "deactivate": "停用",
      "active": "已激活",
      "threshold": "触发时间",
      "minutes": "{{n}} 分钟",
      "contacts": "紧急联系人",
      "addContact": "添加联系人",
      "triggered": "安全开关已触发！"
    },
    "emergency": {
      "title": "紧急报警",
      "police": "报警 112",
      "fire": "火警/急救 119",
      "myAddress": "当前位置",
      "copyAddress": "复制地址",
      "copied": "已复制",
      "call112": "拨打 112",
      "call119": "拨打 119",
      "description": "一键紧急呼叫",
      "addressLoading": "正在加载地址...",
      "findingLocation": "正在查找位置...",
      "addressNotFound": "未找到地址",
      "needPermission": "需要定位权限",
      "policeLabel": "警察",
      "fireLabel": "消防/急救",
      "gettingLocation": "正在获取位置...",
      "getCurrentLocation": "获取当前位置",
      "foreignerTip": "💡 如果您是外国人，报警时请向接线员朗读此地址",
      "foreignerTipEn": "Share this address when calling emergency services",
      "sosTitle": "向联系人发送 SOS",
      "delete": "删除",
      "edit": "编辑",
      "cancel": "取消",
      "save": "保存",
      "sendSms": "发送短信",
      "nameRelation": "姓名 / 关系",
      "phone": "手机号码",
      "presetMessage": "预设信息",
      "namePlaceholder": "例如：妈妈、张三",
      "phonePlaceholder": "仅限数字 (例: 01012345678)",
      "defaultContact": "指定联系人",
      "plusCurrentAddress": "+ 当前位置地址",
      "guideTitle": "紧急指南",
      "guidePolice": "犯罪、事故、危险报警 (警察)",
      "guideFire": "火灾、急救、救援报警 (消防)",
      "guideCivil": "首尔市政投诉咨询",
      "guideTourist": "外国游客投诉咨询 (24小时)",
      "confirmDelete": "确定要删除该联系人吗？",
      "flashcardTitle": "求助卡 (请展示给韩国人)",
      "flashcardMessage": "我是外国人，需要帮助。请帮我拨打警察(112)或消防(119)。",
      "flashcardSpeak": "播放语音",
      "guideTourist1330": "旅游警察 1330"
    },
    "weather": {
      "temp": "气温",
      "humidity": "湿度",
      "pm10": "细颗粒物",
      "airQuality": "空气质量",
      "uv": "紫外线指数"
    },
    "traffic": {
      "title": "交通情况",
      "smooth": "畅通",
      "slow": "缓行",
      "congested": "拥堵"
    },
    "settings": {
      "title": "设置",
      "language": "语言",
      "notification": "通知",
      "congestionAlert": "拥挤警报",
      "radius": "警报半径",
      "theme": "主题",
      "about": "关于我们",
      "version": "版本",
      "privacy": "隐私政策",
      "terms": "服务条款",
      "on": "开启",
      "off": "关闭",
      "persons": "{{n}} 人",
      "appTitle": "安心 IN 首尔",
      "valueBeta": "0.1.0 Beta",
      "valueDistance": "500米",
      "valueTime": "60分钟",
      "valuePersons": "0 人",
      "inviteTitle": "邀请好友",
      "inviteMenu": "向好友推荐应用",
      "inviteMessage": "安装“安心 IN 首尔”，安全地共享位置吧！\n下载链接：https://ansim-in-seoul.vercel.app",
      "inviteModalTitle": "发送邀请函",
      "inviteSendBtn": "发送短信",
      "importContacts": "从通讯录导入"
    },
    "safety": {
      "policeTitle": "警察局",
      "hospitalTitle": "医院 / 医疗机构",
      "embassyTitle": "大使馆",
      "defaultPhonePolice": "112 (紧急)",
      "defaultPhoneHospital": "119 (紧急) / 1339",
      "defaultPhoneEmbassy": "1345 (出入境管理)",
      "visitWebsite": "访问官方网站",
      "addressPlaceholder": "如需详细帮助，请亲自前往该机构。",
      "noticeTitle": "紧急通知:",
      "noticeDesc": "外国人在紧急情况下可获得24小时支持。请使用底部的“紧急报警”菜单以获得即时响应。"
    },
    "error": {
      "network": "发生网络错误。",
      "permission": "需要定位权限。",
      "unknown": "发生未知错误。"
    }
  }
},
  es: {
  "translation": {
    "appName": "Ansim IN Seúl",
    "slogan": "En cualquier lugar de Seúl, a tu lado",
    "importContacts": "Cargar desde Contactos",
    "nav": {
      "home": "Inicio",
      "location": "Ubicación",
      "emergency": "Emergencia",
      "settings": "Ajustes"
    },
    "congestion": {
      "title": "Nivel de Multitud",
      "level1": "Poca gente",
      "level2": "Normal",
      "level3": "Poco concurrido",
      "level4": "Concurrido",
      "level5": "Muy concurrido",
      "unknown": "Sin datos",
      "populationLabel": "Población est.",
      "population": "~{{min}}k - {{max}}k personas",
      "eventsTitle": "Eventos en curso",
      "updatedAt": "A las {{time}}",
      "forecast": "Pronóstico",
      "msgLevel1": "El área tiene poca gente. Puedes caminar cómodamente.",
      "msgLevel2": "El área es normal. El flujo de personas es fluido.",
      "msgLevel3": "El área está un poco concurrida. Podrías sentirlo ocupado.",
      "msgLevel4": "El área está concurrida. Por favor camina con precaución.",
      "msgLevel5": "El área está muy concurrida. Ten cuidado para evitar accidentes."
    },
    "map": {
      "myLocation": "Mi ubicación",
      "zoomIn": "Acercar",
      "zoomOut": "Alejar",
      "filter": "Filtro",
      "allCategory": "Todo",
      "loading": "Cargando datos...",
      "loadError": "Error al cargar datos",
      "retry": "Reintentar"
    },
    "home": {
      "addNewGroup": "+ Añadir Nuevo Grupo",
      "viewMember": "👁️ Miembros",
      "hideMember": "👁️ Ocultar",
      "groupModalTitle": "Unirse / Crear Grupo",
      "groupModalDesc": "Ingresa primero el nombre que usarás en el grupo.",
      "namePlaceholder": "Tu nombre (2~5 caracteres)",
      "joinDivider": "Unirse con Código",
      "codePlaceholder": "Código de 6 dígitos",
      "joinBtn": "Unirse",
      "createDivider": "O Crear un Nuevo Grupo",
      "groupNamePlaceholder": "Nombre del nuevo grupo (2~5 caracteres)",
      "createBtn": "Crear",
      "groupDetailTitle": "Detalles de [{{name}}]",
      "code": "Código:",
      "remainingTime": "⏳ Tiempo restante {{time}}",
      "hostBadge": "👑 Anfitrión",
      "shareInvite": "Compartir/Invitar",
      "noticePlaceholder": "Ingresa un aviso...",
      "saveBtn": "Guardar",
      "editBtn": "Editar",
      "deleteBtn": "Eliminar",
      "leaveBtn": "Salir",
      "closeGroupBtn": "Cerrar Grupo",
      "confirmNoticeDelete": "¿Seguro que quieres eliminar el aviso?",
      "noticeUpdateFail": "Error al actualizar el aviso.",
      "noticeDeleteFail": "Error al eliminar el aviso.",
      "invalidNameLength": "Por favor ingresa tu nombre en 2-5 caracteres.",
      "invalidGroupNameLength": "Por favor ingresa un nombre de grupo en 2-5 caracteres.",
      "invalidCode": "Por favor ingresa un código de 6 dígitos.",
      "alreadyJoined": "Ya te has unido a este grupo.",
      "maxGroups": "Puedes unirte a un máximo de 3 grupos.",
      "createError": "Ocurrió un error al crear el grupo.",
      "shareTitle": "Unirse a Compartir Ubicación",
      "shareText": "¡Únete al grupo {{name}}!\nCódigo: {{code}}\n\nIngresa este código en la aplicación Ansim IN Seúl para compartir tu ubicación en tiempo real.",
      "shareSuccess": "Mensaje de invitación copiado.",
      "needMyLocation": "Por favor confirma tu ubicación primero.",
      "routeNotFound": "Ruta no encontrada.",
      "routeError": "Error al obtener la ruta.",
      "manualLocationTitle": "Establecer Ubicación Manual",
      "manualLocationDesc": "Permiso de ubicación denegado. Busca un lugar (ej. Estación Gangnam) o dirección.",
      "manualLocationPlaceholder": "Buscar un lugar o dirección",
      "searchBtn": "Buscar",
      "searchFail": "No se encontraron resultados.",
      "groupClosedAlert": "El anfitrión ha cerrado el grupo [{{name}}].",
      "groupExpiredAlert": "Han pasado 24 horas, el grupo [{{name}}] se ha cerrado automáticamente.",
      "distanceM": "{{n}}m",
      "distanceKm": "{{n}}km",
      "timeMin": "{{n}} min",
      "timeHourMin": "{{h}} h {{m}} min",
      "me": "Yo",
      "permissionDenied": "Permiso de ubicación denegado. Revisa los ajustes.",
      "noticeNotification": "Aviso [{{name}}]",
      "locationSuccess": "Ubicación identificada exitosamente:",
      "hotspotWarningTitle": "🚨 Advertencia de Multitud",
      "hotspotWarningDesc": "Actualmente se reportan grandes multitudes en Myeongdong, Hongdae e Itaewon. Por favor mantente seguro."
    },
    "category": {
      "all": "Todo",
      "station": "Metro",
      "commerce": "Comercial",
      "entertainment": "Entretenimiento",
      "food": "Comida",
      "tourism": "Turismo",
      "market": "Mercado",
      "landmark": "Monumento",
      "park": "Parque",
      "education": "Universidad"
    },
    "sharing": {
      "title": "Compartir Ubicación",
      "start": "Iniciar",
      "stop": "Detener",
      "request": "Solicitar Ubicación",
      "pending": "Pendiente",
      "approved": "Compartiendo",
      "rejected": "Rechazado",
      "noGroup": "Sin grupo",
      "createGroup": "Crear Grupo",
      "joinGroup": "Unirse al Grupo",
      "myLocation": "Mi Ubicación",
      "lastSeen": "hace {{time}}"
    },
    "privateSharing": {
      "title": "Compartir Ubicación 1:1 (Pago)",
      "desc": "Comparte tu ubicación 1:1 con un familiar o amigo.",
      "paidInfo": "💡 Compartir 1:1 es un servicio premium que requiere pago por persona.\nSi se elimina, se necesita un nuevo pago para volver a registrar.",
      "myMembers": "Mis Miembros ({{count}})",
      "demoBtn": "🚀 Demo",
      "addBtn": "Añadir",
      "emptyTitle": "No hay miembros registrados",
      "emptyDesc": "Añade a un ser querido de tus contactos para compartir tu ubicación.",
      "addMemberBtn": "Añadir Miembro",
      "unnamed": "Sin Nombre",
      "active": "Compartiendo",
      "inactive": "Inactivo",
      "requestLocation": "Solicitar",
      "start": "Iniciar",
      "stop": "Detener",
      "delete": "Eliminar",
      "addModalTitle": "Añadir desde Contactos",
      "payAddBtn": "Pagar/Añadir",
      "editModalTitle": "Editar Nombre",
      "editModalDesc": "Ingresa el apodo del miembro ({{phone}})",
      "editModalPlaceholder": "ej. Mamá, Juan Pérez",
      "save": "Guardar",
      "cancel": "Cancelar",
      "confirmDelete": "¿Estás seguro de eliminarlo? Re-registrar requerirá un pago.",
      "demoCreated": "Miembro de prueba añadido.",
      "confirmRequest": "¿Enviar solicitud de ubicación a {{name}}? (Requiere pago de 1,100 KRW)",
      "requestSuccess": "Pago completado y solicitud enviada.",
      "requestFail": "Error en la solicitud: {{msg}}",
      "updateFail": "Error al actualizar el nombre: {{msg}}",
      "requestSent": "Solicitud enviada a {{name}}. Aparecerán en el mapa cuando acepten."
    },
    "deadman": {
      "title": "Interruptor de Seguridad",
      "description": "Alerta automáticamente a tus contactos si no se detecta movimiento.",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "active": "Activo",
      "threshold": "Tiempo Límite",
      "minutes": "{{n}} min",
      "contacts": "Contactos de Alerta",
      "addContact": "Añadir Contacto",
      "triggered": "¡El Interruptor de Seguridad se ha activado!"
    },
    "emergency": {
      "title": "Emergencia",
      "police": "Policía 112",
      "fire": "Bomberos 119",
      "myAddress": "Ubicación Actual",
      "copyAddress": "Copiar Dirección",
      "copied": "Copiado",
      "call112": "Llamar al 112",
      "call119": "Llamar al 119",
      "description": "Llamada de emergencia con un toque",
      "addressLoading": "Cargando dirección...",
      "findingLocation": "Buscando ubicación...",
      "addressNotFound": "Dirección no encontrada",
      "needPermission": "Se necesita permiso de ubicación",
      "policeLabel": "Policía",
      "fireLabel": "Bomberos",
      "gettingLocation": "Obteniendo ubicación...",
      "getCurrentLocation": "Obtener Ubicación Actual",
      "foreignerTip": "💡 Si eres extranjero, por favor lee esta dirección al reportar",
      "foreignerTipEn": "Share this address when calling emergency services",
      "sosTitle": "SOS a Contacto",
      "delete": "Eliminar",
      "edit": "Editar",
      "cancel": "Cancelar",
      "save": "Guardar",
      "sendSms": "Enviar SMS",
      "nameRelation": "Nombre / Relación",
      "phone": "Número de Teléfono",
      "presetMessage": "Mensaje Predefinido",
      "namePlaceholder": "ej. Madre, Juan Pérez",
      "phonePlaceholder": "Solo números (ej. 01012345678)",
      "defaultContact": "Contacto Designado",
      "plusCurrentAddress": "+ Dirección actual",
      "guideTitle": "Guía de Emergencia",
      "guidePolice": "Reportar Crimen, Accidente, Peligro (Policía)",
      "guideFire": "Reportar Incendio, Emergencia Médica (Bomberos)",
      "guideCivil": "Quejas Civiles de Seúl",
      "guideTourist": "Quejas de Turistas Extranjeros (24/7)",
      "confirmDelete": "¿Seguro que quieres eliminar este contacto?",
      "flashcardTitle": "Tarjeta de Ayuda (Mostrar a un coreano)",
      "flashcardMessage": "Soy extranjero. Necesito ayuda. Por favor llame a la policía (112) o a los bomberos (119).",
      "flashcardSpeak": "Reproducir Audio",
      "guideTourist1330": "Policía Turística 1330"
    },
    "weather": {
      "temp": "Temperatura",
      "humidity": "Humedad",
      "pm10": "Polvo Fino",
      "airQuality": "Calidad del Aire",
      "uv": "Índice UV"
    },
    "traffic": {
      "title": "Tráfico",
      "smooth": "Fluido",
      "slow": "Lento",
      "congested": "Congestionado"
    },
    "settings": {
      "title": "Ajustes",
      "language": "Idioma",
      "notification": "Notificaciones",
      "congestionAlert": "Alerta de Multitud",
      "radius": "Radio de Alerta",
      "theme": "Tema",
      "about": "Acerca de",
      "version": "Versión",
      "privacy": "Política de Privacidad",
      "terms": "Términos de Servicio",
      "on": "Activado",
      "off": "Desactivado",
      "persons": "{{n}} persona(s)",
      "appTitle": "Ansim IN Seúl",
      "valueBeta": "0.1.0 Beta",
      "valueDistance": "500m",
      "valueTime": "60 min",
      "valuePersons": "0 persona(s)",
      "inviteTitle": "Invitar Amigos",
      "inviteMenu": "Recomendar App",
      "inviteMessage": "¡Instala Ansim IN Seúl y comparte tu ubicación de forma segura!\nDescarga: https://ansim-in-seoul.vercel.app",
      "inviteModalTitle": "Enviar Invitación",
      "inviteSendBtn": "Enviar SMS",
      "importContacts": "Cargar desde Contactos"
    },
    "safety": {
      "policeTitle": "Estación de Policía",
      "hospitalTitle": "Hospital / Centro Médico",
      "embassyTitle": "Embajada",
      "defaultPhonePolice": "112 (Emergencia)",
      "defaultPhoneHospital": "119 (Emergencia) / 1339",
      "defaultPhoneEmbassy": "1345 (Inmigración)",
      "visitWebsite": "Visitar Sitio Oficial",
      "addressPlaceholder": "Por favor visita las instalaciones para asistencia detallada.",
      "noticeTitle": "Aviso de Emergencia:",
      "noticeDesc": "Hay asistencia 24/7 disponible para extranjeros durante emergencias. Usa el menú de Emergencia abajo para respuesta inmediata."
    },
    "error": {
      "network": "Ocurrió un error de red.",
      "permission": "Se requiere permiso de ubicación.",
      "unknown": "Ocurrió un error desconocido."
    }
  }
}
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['ko', 'en', 'ja', 'zh', 'es'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
